import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressSpinnerCont, SpinnerMetaDataCont } from './ProgressSpinner.styles';
import useProgress from '../../hooks/useProgress';
import { BodyRegularS } from '../../styles/globals';
import { THEME as theme } from '../../styles/theme';
import ProgressBar from '../ProgressBar/ProgressBar';

interface IProgressSpinner {
  inProgress: boolean;
  downloadFinished: boolean;
}
const ProgressSpinner:FC<IProgressSpinner> = ({inProgress,downloadFinished}) => {
  const {t} = useTranslation();
  const {progress} = useProgress(inProgress, downloadFinished);
  const progressValue = downloadFinished ? '100%' : `${progress}%`;
  const renderProgressBar = useMemo(() => (<ProgressSpinnerCont>
    <ProgressBar
      progress={progressValue}
      barMode="strong"
      contWidth="320px"
      height="8px"
      background={theme.colors.neutral.primary[0]}
    />
    <SpinnerMetaDataCont>
      <BodyRegularS>{t('viewSurvey.reportsSetup.downloadModal.progress')}</BodyRegularS>
      <BodyRegularS>{progressValue}</BodyRegularS>

    </SpinnerMetaDataCont>
  </ProgressSpinnerCont>), [progressValue]);

  return(<div>
    {renderProgressBar}
  </div>);
};

export default ProgressSpinner;
